<template>
    <div>
        <HeaderBreadcrumbs :items="[
            { label: 'Publisher Group', to: '/publisher-group' },
            { label: 'Add New' }
        ]" title="New Publisher Group" />

      
        <div class="flex-col justify-start items-center bg-white w-full shadow-sm rounded-lg">
              <FormDataPublisherGroup 
        :form="form" 
        :vendorsAlready="vendorsAlready" 
        :invalidName.sync="invalidName"
        :invalidNameEmpty.sync="invalidNameEmpty"
        :invalidVendorsEmpty.sync="invalidVendorsEmpty" 
        />
        <div class="px-4 pb-4">
            <button class="bg-blue-700 text-white rounded-lg p-1.5 px-2" @click="addPublisherGroup()">Save</button>
             <button class="bg-white text-gray-700 border ml-3 rounded-lg p-1.5 px-2" @click="handleCancel()">Cancel</button>
        </div>
          
        </div>
    </div>

</template>

<script>
import { mapActions, mapState } from 'vuex';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import { EventBus } from '../../../event-bus'
import FormDataPublisherGroup from '../form-data-publisher-group.vue';


export default {
    name: 'CreatePublisherGroup',
    components: {
        HeaderBreadcrumbs,
        FormDataPublisherGroup
    },
    data() {
        return {
            form: {
                name: '',
                vendors: null,
            },
            vendorsAlready: [],
            invalidName: false,
            invalidNameEmpty: false,
            invalidVendorsEmpty: false,
        };

    },
    computed: {
        ...mapState({
            successMessage: (state) => state.vendors.successMessage,
            errorMessage: (state) => state.vendors.errorMessage,

        }),
    },

    watch: {
        successMessage () {
            if (!this.successMessage) return;
            EventBus.$emit('show-toast', {
                message: 'New publisher group has been added.',
                type: 'success',
            });
            this.$router.push('/publisher-group');
        },
        errorMessage: {
            handler(errorObj) {
                if (!errorObj) return;
                const error = errorObj.message.data;
                if (error === 'Name already exists.') {
                    this.invalidName = true;
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('vendors', ['createPublisherGroup']),
        
        async addPublisherGroup() {
            this.invalidNameEmpty = false;
            this.invalidVendorsEmpty = false;

            const errors = {
                name: !this.form.name?.trim(),
                vendors: !this.form.vendors?.length
            };

            this.invalidNameEmpty = errors.name;
            this.invalidVendorsEmpty = errors.vendors;

            if (errors.name || errors.vendors) return;
            try {

            const payload = {
                name: this.form.name.trim(),
                vendors: this.form.vendors.map(v => v.id),
            };
            await this.createPublisherGroup(payload);

            } catch (err) {
                 this.vendorsAlready = err.duplicates?.map?.(v => v.id) || [];
            }
        },
        handleCancel() {
              this.$router.push('/publisher-group');
        }

       

    },
};
</script>